(function($){
    // JS
    window.Scroll = {

        // Show or hide the search form
        //======================================================================
        stickySidebarOnScrollIntoView: function()
        {
            var $window = $(window),
                $sidebarAnchor = $('#sidebar_anchor'),
                $sidebar = $('#sidebar');

            $window.scroll(function(e){
                var window_top = $window.scrollTop();
                var div_top = $sidebarAnchor.offset().top;
                if(window_top > div_top) {
                    // make the div sticky
                    $sidebar.addClass('stick');
                    $sidebarAnchor.height($sidebar.height());
                } else {
                    // unstick
                    $sidebar.removeClass('stick');
                    $sidebarAnchor.height(0);
                }

            });
        }
    }

    // Run
    $(function(){
        //Scroll.stickySidebarOnScrollIntoView();
    });


}(jQuery))